const $ = require('jquery');
window.jQuery = $;
require("affix");
var ScrollMagic = require("scrollmagic");
var _ = require("underscore");
var controller = new ScrollMagic.Controller();
var navbar = $('#vad-navbar');
var navButtons = $('#navigation-container');
var navigation = document.querySelector("#navigation");

$(() => {
  navButtons = $('#navigation-container');
  navbar = $('#vad-navbar');
  controller = new ScrollMagic.Controller();
  navigation = document.querySelector("#navigation");
  const navigationContainer = document.querySelector("#navigation-container");
  const button = document.querySelector("#active");
  button.addEventListener("click", toggleOpen);
  document.getElementById("active").removeAttribute("href");
});

function toggleOpen() {
  navigation.classList.toggle('open');
}

// Hide show Proceed navigation and logo

let options1 = {
  root: null,
  threshold: [.32]
}

function hideNav(entryArray) {
  let nav = document.querySelector("#navigation-container")
  entryArray[0].isIntersecting ? nav.style.visibility = "visible" : nav.style.visibility = "hidden";
}

let observer = new IntersectionObserver(hideNav, options1);
observer.observe(document.querySelector("#branding-image"));

let options2 = {
  root: null,
  threshold: [.1]
}

function hideLogo(entryArray) {
  let brandLogo = document.querySelector("#navbar-brand")
  entryArray[0].isIntersecting ? brandLogo.style.visibility = "visible" : brandLogo.style.visibility = "hidden";
}

let observer2 = new IntersectionObserver(hideLogo, options2);
observer2.observe(document.querySelector("#branding-image"));